/**
 * MG Forms — mejora progresiva del envío.
 *
 * El <form> ya funciona sin JS (POST a admin-post.php, confirmación server-side).
 * Aquí interceptamos para enviar por REST con spinner, gestión de errores inline,
 * foco accesible y reset de Turnstile. Si el fetch falla, dejamos que el navegador
 * haga el submit nativo (fallback total).
 *
 * Vanilla JS: sin dependencia de jQuery para que el bundle sea independiente.
 */
(function () {
  'use strict'; 

  if (typeof window.MGF === 'undefined') return;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    scan(document);
    observeForms();
  });

  // Escanea e inicializa todos los formularios MG aún no inicializados dentro de
  // `root`. initForm es idempotente, así que llamarlo de más es inofensivo.
  function scan(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('form.mgf-form'), initForm);
    if (root && root.matches && root.matches('form.mgf-form')) initForm(root);
  }

  // Los formularios pueden inyectarse por AJAX o recargarse dentro de un modal
  // DESPUÉS del load inicial (varios en la misma web). Observamos el DOM y
  // re-escaneamos (debounce) para inicializar los nuevos. El tema también puede
  // forzarlo con window.MGF.refresh(nodoOpcional).
  function observeForms() {
    window.MGF.refresh = function (root) { scan(root || document); };
    if (!('MutationObserver' in window) || !document.body) return;
    var pending = false;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          if (pending) return;
          pending = true;
          setTimeout(function () { pending = false; scan(document); }, 60);
          return;
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /**
   * Rellena los campos portadores de metadata (mismo mecanismo que GF:
   * saveTrackStorageToLead + formSubmitSetMetadataUser). Reutiliza el
   * localStorage["metadataUser"] que main.js mantiene en todas las páginas,
   * así idOferta / UTM / source llegan idénticos al pipeline y al CRM.
   */
  function populateMetadata(form) {
    if (typeof window.localStorage === 'undefined') return;
    try {
      if (typeof window.mgUtils !== 'undefined' && typeof window.mgUtils.googleAdwordsCodes === 'function') {
        try { window.mgUtils.googleAdwordsCodes(); } catch (e) {}
      }
      var raw = window.localStorage.getItem('metadataUser');
      if (!raw) return;
      var meta = JSON.parse(raw);

      var dataField = form.querySelector('.hidden_data_usr');
      if (dataField) dataField.value = raw;

      var refField = form.querySelector('.hidden_referrer');
      if (refField && meta.utils && meta.utils.source) refField.value = meta.utils.source;

      var urlField = form.querySelector('.hidden_current_url');
      if (urlField) urlField.value = window.location.href;

      // Campos UTM (para el jsonlead origin). El JS del tema los rellenaba vía
      // .gfield (que MG Forms no usa), así que los poblamos aquí desde la metadata
      // (meta.utils.utm_*). Matcheo por prefijo para soportar nombres tipo utm_source_35.
      var utils = meta.utils || {};
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (key) {
        var val = utils[key];
        if (!val) return;
        Array.prototype.forEach.call(form.querySelectorAll('input, textarea'), function (inp) {
          var n = inp.getAttribute('name') || '';
          if (n === key || n.indexOf(key) === 0) inp.value = val;
        });
      });
    } catch (e) {}
  }

  function initForm(form) {
    // Idempotente: un mismo <form> solo se inicializa una vez (evita doble listener
    // de submit si el re-escaneo del observer lo vuelve a ver). Un form recargado
    // por modal es un NODO nuevo → sin la marca → se inicializa de nuevo.
    if (form._mgfInit) return;
    form._mgfInit = true;

    // Con JS activo: quitamos la marca "nojs" (el envío es SOLO AJAX) y HABILITAMOS
    // el botón de envío (arranca disabled). Sin JS, la clase permanece, el botón
    // sigue disabled (ni click ni Enter envían) y el <noscript> avisa.
    form.classList.remove('mgf-form--nojs');
    Array.prototype.forEach.call(form.querySelectorAll('.mgf-submit'), function (b) { b.disabled = false; });
    setupTurnstile(form);
    setupPhones(form);        // teléfono internacional (intl-tel-input)
    setupFileInputs(form);    // preview de imágenes al seleccionar archivos
    setupEmailChecks(form);   // sugerencia de corrección de email (typos .con→.com)
    populateMetadata(form);   // poblar carriers (url/referrer/metadata) YA en carga
    setupConditions(form);    // lógica condicional de campos (show/hide en vivo)
    setupDatepickers(form);   // calendarios flatpickr
    setupAppointments(form);  // selector de cita (calendario día + slots de hora)
    setupSteps(form);         // navegación multipágina (pasos)
    setupCitaPrevia(form);    // UX por tarjetas del formulario de cita previa (coche/moto→marca→centro…)
    setupCollapsibleSections(form); // secciones plegables (acordeón) marcadas con data-mgf-collapsible

    form.addEventListener('submit', function (e) {
      // SOLO AJAX: el formulario NUNCA hace POST nativo. Toda validación server-side
      // vuelve por AJAX y se pinta inline (NUNCA recarga con ?mgf_state). Prohibido
      // validar con refresh de página.
      e.preventDefault();

      // Grupos de opciones OBLIGATORIOS pintados como tarjetas (p.ej. el canal
      // Particular/Autónomo/Empresa): el radio real es invisible, así que la
      // burbuja del navegador puede pasar desapercibida → marcamos el error
      // inline y llevamos la vista al campo. Va ANTES de reportValidity.
      clearErrors(form);
      if (!validateChoiceGroups(form)) return;

      // Validación de OBLIGATORIOS en CLIENTE (el <form> lleva novalidate → forzamos
      // reportValidity): si un required VISIBLE está vacío, el navegador lo señala y
      // no enviamos. Los ocultos por condición están disabled → no cuentan. En
      // multipágina la validación la lleva setupSteps por paso.
      var isMultistep = !!form.querySelector('.mgf-steps');
      if (!isMultistep && typeof form.reportValidity === 'function' && !form.reportValidity()) {
        return;
      }

      // Validación de teléfonos (intl-tel-input): si el número escrito no es válido
      // para el país seleccionado, se marca inline y no se envía.
      clearErrors(form);
      if (!validatePhones(form)) return;
      // Emails con typo evidente (.con→.com, gmial→gmail, dominio+basura): avisamos
      // UNA vez con la sugerencia y no enviamos; si insisten, el 2º envío pasa.
      if (!validateEmails(form)) return;

      populateMetadata(form);
      normalizePhones(form);   // pasa cada teléfono a formato internacional (+34...)

      if (!window.fetch || !window.FormData) {
        showFormError(form, 'Tu navegador no permite enviar el formulario. Actualízalo o activa JavaScript.');
        return;
      }

      clearErrors(form);
      setLoading(form, true);

      // OJO: NO enviamos X-WP-Nonce, y ELIMINAMOS el campo _wpnonce del FormData.
      // Ese campo (nonce de la acción mgf_submit, para el POST nativo) NO es un
      // nonce 'wp_rest' válido; WordPress REST lee $_REQUEST['_wpnonce'], lo valida
      // como wp_rest, falla y devuelve 403 rest_cookie_invalid_nonce a TODOS (no
      // solo logueados) antes de nuestro permission_callback. La seguridad real del
      // endpoint es Turnstile + honeypot.
      var body = new FormData(form);
      body.delete('_wpnonce');
      fetch(window.MGF.restUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: body
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (res) {
          setLoading(form, false);
          if (res && res.success) {
            handleConfirmation(form, res.confirmation);
          } else {
            handleErrors(form, res && res.errors ? res.errors : {});
            resetTurnstile(form);
          }
        })
        .catch(function () {
          // Fallo de red/servidor: aviso INLINE y a reintentar. NUNCA POST nativo
          // (eso recargaría). El token de Turnstile se resetea para reintentar.
          setLoading(form, false);
          showFormError(form, 'No se ha podido enviar. Revisa tu conexión e inténtalo de nuevo.');
          resetTurnstile(form);
        });
    });
  }

  function handleConfirmation(form, conf) {
    // Sin confirmación explícita (no debería pasar): mensaje genérico inline, NUNCA
    // POST nativo (recargaría).
    if (!conf) { conf = { type: 'message', message: '¡Gracias! Hemos recibido tu solicitud.' }; }

    if (conf.type === 'redirect' && conf.url) {
      window.location.href = conf.url;
      return;
    }
    // Mensaje: reemplazar el formulario y mover el foco (a11y).
    var box = document.createElement('div');
    box.className = 'mgf-confirmation';
    box.setAttribute('role', 'status');
    box.setAttribute('tabindex', '-1');
    box.innerHTML = conf.message || '¡Gracias!';
    form.parentNode.replaceChild(box, form);
    box.focus();

    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({ event: 'mgf_form_submit', formSlug: form.getAttribute('data-mgf-slug') });
    }
  }

  function handleErrors(form, errors) {
    var first = null;

    if (errors._form) {
      var fb = document.createElement('div');
      fb.className = 'mgf-form-error';
      fb.setAttribute('role', 'alert');
      fb.textContent = errors._form;
      form.insertBefore(fb, form.firstChild);
      first = form.querySelector('.mgf-input');
    }

    Object.keys(errors).forEach(function (name) {
      if (name === '_form') return;
      var input = form.querySelector('[name="' + name + '"]') || form.querySelector('[name="' + name + '[]"]');
      if (!input) return;
      var wrap = input.closest('.mgf-field');
      if (wrap) {
        wrap.classList.add('mgf-field--error');
        var p = document.createElement('p');
        p.className = 'mgf-error';
        p.setAttribute('role', 'alert');
        p.textContent = errors[name];
        wrap.appendChild(p);
      }
      input.setAttribute('aria-invalid', 'true');
      expandCollapsedSectionOf(input); // si está en una sección plegada, abrirla
      if (!first) first = input;
    });

    if (first) { expandCollapsedSectionOf(first); first.focus(); }
    announce(form, 'Revisa los campos marcados.');
  }

  // Si el elemento está dentro de una sección plegable cerrada, la abre (para que
  // un error/foco en un campo oculto sea visible).
  function expandCollapsedSectionOf(el) {
    if (!el || !el.closest) return;
    var body = el.closest('.mgf-section-body');
    if (!body) return;
    var head = body.previousElementSibling;
    if (head && head.classList.contains('mgf-section--collapsible') && !head.classList.contains('is-open')) {
      head.classList.add('is-open');
      head.classList.remove('is-collapsed');
      head.setAttribute('aria-expanded', 'true');
    }
  }

  // Secciones plegables (acordeón). El servidor marca la cabecera con
  // data-mgf-collapsible; aquí agrupamos los campos siguientes (hasta la próxima
  // sección) en un contenedor .mgf-section-body y alternamos el estado al pulsar.
  function setupCollapsibleSections(form) {
    var heads = form.querySelectorAll('.mgf-section--collapsible');
    if (!heads.length) return;

    Array.prototype.forEach.call(heads, function (head) {
      if (head._mgfCollapse) return;
      head._mgfCollapse = true;

      var body = document.createElement('div');
      body.className = 'mgf-section-body';
      // Solo absorbemos campos (.mgf-field) y bloques HTML (.mgf-html) hasta el
      // siguiente elemento estructural. Así, si la sección plegable es la ÚLTIMA,
      // NO nos comemos el Turnstile ni el botón de enviar (quedarían ocultos al plegar).
      var node = head.nextElementSibling;
      while (node && node.classList && (node.classList.contains('mgf-field') || node.classList.contains('mgf-html'))) {
        var next = node.nextElementSibling;
        body.appendChild(node);
        node = next;
      }
      head.parentNode.insertBefore(body, node); // tras los campos movidos

      head.classList.add('is-collapsed');
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.setAttribute('aria-expanded', 'false');

      function toggle() {
        var open = head.classList.toggle('is-open');
        head.classList.toggle('is-collapsed', !open);
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      head.addEventListener('click', toggle);
      head.addEventListener('keydown', function (e) {
        var k = e.key || e.keyCode;
        if (k === 'Enter' || k === ' ' || k === 13 || k === 32) { e.preventDefault(); toggle(); }
      });
    });

    // Al enviar (capture → antes del submit principal): expandir secciones plegadas
    // con algún obligatorio inválido, para que reportValidity pueda señalarlo (un
    // required en display:none no se puede enfocar/mostrar).
    if (!form._mgfCollapseSubmit) {
      form._mgfCollapseSubmit = true;
      form.addEventListener('submit', function () {
        Array.prototype.forEach.call(form.querySelectorAll('.mgf-section-body'), function (body) {
          var head = body.previousElementSibling;
          if (!head || !head.classList.contains('mgf-section--collapsible') || head.classList.contains('is-open')) return;
          var invalid = false;
          Array.prototype.forEach.call(body.querySelectorAll('input, select, textarea'), function (f) {
            if (!f.disabled && typeof f.checkValidity === 'function' && !f.checkValidity()) invalid = true;
          });
          if (invalid) {
            head.classList.add('is-open');
            head.classList.remove('is-collapsed');
            head.setAttribute('aria-expanded', 'true');
          }
        });
      }, true);
    }
  }

  function showFormError(form, msg) {
    // Aviso de formulario INLINE (arriba del form), sin recargar. Para fallos de
    // red/servidor o navegadores sin fetch.
    var prev = form.querySelector('.mgf-form-error');
    if (prev) prev.remove();
    var fb = document.createElement('div');
    fb.className = 'mgf-form-error';
    fb.setAttribute('role', 'alert');
    fb.textContent = msg;
    form.insertBefore(fb, form.firstChild);
    announce(form, msg);
  }

  function clearErrors(form) {
    Array.prototype.forEach.call(form.querySelectorAll('.mgf-error, .mgf-form-error'), function (el) { el.remove(); });
    Array.prototype.forEach.call(form.querySelectorAll('.mgf-field--error'), function (el) { el.classList.remove('mgf-field--error'); });
    Array.prototype.forEach.call(form.querySelectorAll('[aria-invalid]'), function (el) { el.removeAttribute('aria-invalid'); });
  }

  function announce(form, msg) {
    var live = form.querySelector('.mgf-live');
    if (live) live.textContent = msg;
  }

  function setLoading(form, on) {
    var btn = form.querySelector('.mgf-submit');
    if (btn) { btn.disabled = on; btn.classList.toggle('is-loading', on); }
    form.classList.toggle('mgf-form--loading', on);

    var id = 'mgf-global-spinner';
    if (on && !document.getElementById(id)) {
      var s = document.createElement('div');
      s.id = id;
      s.className = 'spinner-mediagach';
      s.innerHTML = '<div id="shadow"></div><div id="box"></div>';
      document.body.appendChild(s);
    } else if (!on) {
      var ex = document.getElementById(id);
      if (ex) ex.remove();
    }
  }

  /**
   * Render EXPLÍCITO de Turnstile. Los formularios viven en modales ocultos al
   * cargar; el auto-render deja un "hueco" vacío. Renderizamos cada widget solo
   * cuando se hace visible (IntersectionObserver + reintentos hasta que api.js
   * cargue).
   */
  function setupTurnstile(form) {
    var holder = form.querySelector('.cf-turnstile');
    if (!holder || !window.MGF.turnstileKey) return;

    var state = { id: null };
    form._mgfTs = state;
    var wasVisible = false;

    // Render FRESCO: limpia cualquier widget anterior (el tema mueve el modal en el
    // DOM al abrirlo -> .remove()+.appendTo- y eso rompe el iframe de Turnstile,
    // dejando un rectángulo vacío al reabrir). Por eso re-renderizamos entero.
    function freshRender() {
      if (typeof window.turnstile === 'undefined') return;
      if (state.id !== null) { try { window.turnstile.remove(state.id); } catch (e) {} state.id = null; }
      holder.innerHTML = '';
      try { state.id = window.turnstile.render(holder, { sitekey: window.MGF.turnstileKey }); } catch (e) {}
    }

    // Renderiza al hacerse visible; y RE-renderiza en cada transición oculto→visible
    // (cada apertura/reapertura del modal).
    function check() {
      var visible = holder.offsetParent !== null;
      if (visible && !wasVisible) freshRender();
      wasVisible = visible;
    }

    if ('IntersectionObserver' in window) {
      // Sin filtrar por isIntersecting: queremos actualizar wasVisible también al
      // cerrarse (para detectar la siguiente reapertura).
      new IntersectionObserver(function () { check(); }).observe(holder);
    }
    // Poll de respaldo: cubre api.js aún no cargado y navegadores donde el
    // observer no dispara en el cierre/reapertura del modal.
    var timer = setInterval(check, 500);
    form._mgfTsTimer = timer;
    check();
  }

  /**
   * Sugerencia de corrección de email (mini-Mailcheck propio, sin dependencias).
   * type=email solo valida la sintaxis, así que .con / .com.miguel / gmial.com pasan.
   * Aquí detectamos el typo y ofrecemos "¿Quisiste decir juan@gmail.com?" clicable.
   * Es no bloqueante en el día a día (blur) y avisa UNA vez al enviar.
   */
  var MGF_EMAIL_DOMAINS = [
    'gmail.com', 'googlemail.com', 'hotmail.com', 'hotmail.es', 'outlook.com', 'outlook.es',
    'live.com', 'live.es', 'yahoo.com', 'yahoo.es', 'ymail.com', 'icloud.com', 'me.com',
    'msn.com', 'aol.com', 'protonmail.com', 'proton.me', 'gmx.com', 'gmx.es',
    'telefonica.net', 'movistar.es', 'terra.es', 'wanadoo.es', 'ono.com', 'orange.es', 'vodafone.es'
  ];
  var MGF_EMAIL_TLDS = ['com', 'es', 'net', 'org', 'info', 'biz', 'io', 'co', 'eu', 'cat', 'fr', 'pt', 'de', 'it', 'mx', 'ar', 'cl'];
  var MGF_EMAIL_SLDS = ['gmail', 'hotmail', 'outlook', 'yahoo', 'live', 'icloud', 'protonmail', 'msn', 'aol'];

  function mgfLev(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (!m) return n; if (!n) return m;
    var prev = [], i, j;
    for (j = 0; j <= n; j++) prev[j] = j;
    for (i = 1; i <= m; i++) {
      var cur = [i];
      for (j = 1; j <= n; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
      }
      prev = cur;
    }
    return prev[n];
  }
  function mgfClosest(str, list, maxDist) {
    var best = null, bestD = maxDist + 1;
    for (var i = 0; i < list.length; i++) {
      var d = mgfLev(str, list[i]);
      if (d < bestD) { bestD = d; best = list[i]; }
    }
    return bestD <= maxDist ? best : null;
  }

  // Devuelve el email sugerido (corregido) o null si no hay typo claro.
  function suggestEmail(raw) {
    if (!raw) return null;
    var email = String(raw).trim();
    var at = email.lastIndexOf('@');
    if (at < 1 || at === email.length - 1) return null;
    var local = email.slice(0, at);
    var domain = email.slice(at + 1).toLowerCase();
    if (domain.indexOf('.') < 0 || /\s/.test(domain)) return null;

    // Ya es un dominio conocido → nada que sugerir.
    if (MGF_EMAIL_DOMAINS.indexOf(domain) !== -1) return null;

    // 1) Dominio conocido + basura detrás (p.ej. gmail.com.miguel → gmail.com).
    for (var i = 0; i < MGF_EMAIL_DOMAINS.length; i++) {
      if (domain.indexOf(MGF_EMAIL_DOMAINS[i] + '.') === 0) return local + '@' + MGF_EMAIL_DOMAINS[i];
    }
    // 2) Dominio muy parecido a uno conocido (gmial.com, hotmial.com, gmail.con).
    var dd = mgfClosest(domain, MGF_EMAIL_DOMAINS, 2);
    if (dd && dd !== domain) return local + '@' + dd;

    // 3) Corrección solo del TLD (.con→.com, .ne→.net) manteniendo el dominio.
    var parts = domain.split('.');
    var tld = parts[parts.length - 1];
    var sld = parts.slice(0, -1).join('.');
    if (MGF_EMAIL_TLDS.indexOf(tld) === -1) {
      var tt = mgfClosest(tld, MGF_EMAIL_TLDS, 1);
      if (tt && tt !== tld) return local + '@' + sld + '.' + tt;
    }
    // 4) Corrección del nombre de dominio (gmial→gmail) con TLD válido.
    if (parts.length === 2) {
      var ss = mgfClosest(parts[0], MGF_EMAIL_SLDS, 1);
      if (ss && ss !== parts[0]) return local + '@' + ss + '.' + tld;
    }
    return null;
  }

  function clearEmailSuggest(input) {
    var wrap = input.closest('.mgf-field');
    if (!wrap) return;
    var el = wrap.querySelector('.mgf-email-suggest');
    if (el) el.remove();
  }
  function showEmailSuggest(input, suggestion) {
    var wrap = input.closest('.mgf-field');
    if (!wrap) return;
    clearEmailSuggest(input);
    var p = document.createElement('p');
    p.className = 'mgf-email-suggest';
    var a = document.createElement('a');
    a.href = '#';
    a.textContent = suggestion;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      input.value = suggestion;
      input._mgfEmailWarned = false;
      clearEmailSuggest(input);
      input.focus();
    });
    p.appendChild(document.createTextNode('¿Quisiste decir '));
    p.appendChild(a);
    p.appendChild(document.createTextNode('?'));
    wrap.appendChild(p);
  }

  function setupEmailChecks(form) {
    var inputs = form.querySelectorAll('input[type="email"]');
    Array.prototype.forEach.call(inputs, function (input) {
      if (input._mgfEmailInit) return;
      input._mgfEmailInit = true;
      input.addEventListener('blur', function () {
        var sug = suggestEmail(input.value);
        input._mgfEmailSuggest = sug;
        if (sug) showEmailSuggest(input, sug); else clearEmailSuggest(input);
      });
      // Al reescribir, se limpia el aviso previo (y el "ya avisado").
      input.addEventListener('input', function () { input._mgfEmailWarned = false; clearEmailSuggest(input); });
    });
  }

  // Al enviar: si hay una sugerencia clara y aún no se ha avisado, mostrarla y NO
  // enviar (una sola vez). Si insisten (2º envío), se permite: puede ser un email
  // legítimo raro. Nunca bloqueamos de forma dura.
  function validateEmails(form) {
    var inputs = form.querySelectorAll('input[type="email"]');
    var blocked = false, first = null;
    Array.prototype.forEach.call(inputs, function (input) {
      if (input.disabled || !(input.value || '').trim()) return;
      var sug = suggestEmail(input.value);
      input._mgfEmailSuggest = sug;
      if (sug && !input._mgfEmailWarned) {
        showEmailSuggest(input, sug);
        input._mgfEmailWarned = true;
        blocked = true;
        if (!first) first = input;
      }
    });
    if (first) first.focus();
    return !blocked;
  }

  /**
   * Previsualización de archivos de imagen: al elegir ficheros en un input .mgf-file
   * pinta thumbnails debajo (para que el usuario "vea" lo que sube; el input file
   * nativo solo muestra el nombre). Soporta selección múltiple.
   */
  function setupFileInputs(form) {
    var inputs = form.querySelectorAll('.mgf-file');
    if (!inputs.length) return;
    Array.prototype.forEach.call(inputs, function (input) {
      if (input._mgfFilePrev) return;
      input._mgfFilePrev = true;

      var box = document.createElement('div');
      box.className = 'mgf-file-preview';
      var wrap = input.closest('.mgf-field') || input.parentNode;
      wrap.appendChild(box);

      input.addEventListener('change', function () {
        box.innerHTML = '';
        var files = input.files ? Array.prototype.slice.call(input.files) : [];
        files.forEach(function (file) {
          if (!file.type || file.type.indexOf('image/') !== 0) return; // solo imágenes
          if (typeof URL === 'undefined' || !URL.createObjectURL) return;
          var url = URL.createObjectURL(file);
          var fig = document.createElement('figure');
          var img = document.createElement('img');
          img.src = url;
          img.alt = file.name;
          img.onload = function () { try { URL.revokeObjectURL(url); } catch (e) {} };
          var cap = document.createElement('figcaption');
          cap.textContent = file.name;
          cap.title = file.name;
          fig.appendChild(img);
          fig.appendChild(cap);
          box.appendChild(fig);
        });
      }); 
    });
  }

  /**
   * Teléfono internacional (intl-tel-input). Mejora CADA input .mgf-tel-intl del
   * formulario (puede haber varios en la misma web) con bandera + prefijo, país
   * por defecto España (+34) y validación. Idempotente por input (._mgfIti) para
   * que el re-escaneo del observer no lo inicialice dos veces. La librería se
   * carga como dependencia del bundle; si aún no está lista, reintenta.
   */
  function setupPhones(form) {
    var inputs = form.querySelectorAll('.mgf-tel-intl');
    if (!inputs.length) return;
    var cfg = window.MGF.intlTel || {};

    function init() {
      if (typeof window.intlTelInput === 'undefined') return false;
      Array.prototype.forEach.call(inputs, function (input) {
        if (input._mgfIti) return; // ya inicializado
        var iti;
        try {
          iti = window.intlTelInput(input, {
            initialCountry: cfg.country || 'es',
            preferredCountries: cfg.preferred || ['es'],
            separateDialCode: true,          // muestra +34 aparte; número nacional en el input
            autoPlaceholder: 'aggressive',   // placeholder = número de ejemplo del país
            // SIN dropdownContainer: el desplegable se monta INLINE dentro del .iti
            // (junto al input), no al final del <body>. Así se posiciona bien tanto en
            // formulario normal como en modal; el z-index alto (CSS) lo pone por
            // encima del contenido del modal. La columna del form no tiene overflow
            // que lo recorte (solo .col-images-modal lo tiene).
            utilsScript: cfg.utils || ''     // formato + validación (libphonenumber)
          });
        } catch (e) { return; }
        input._mgfIti = iti;
      });
      return true;
    }

    // La lib es dependencia del bundle, pero WP Rocket puede diferir/retrasar el JS:
    // reintentamos hasta que window.intlTelInput exista.
    if (!init()) {
      var tries = 0;
      var t = setInterval(function () { if (init() || ++tries > 40) clearInterval(t); }, 200);
    }
  }

  // Valida los teléfonos con intl-tel-input (necesita utils cargado). Solo valida
  // los que tienen valor y están habilitados; los vacíos/obligatorios ya los
  // cubre reportValidity. Marca inline y devuelve false si alguno es inválido.
  function validatePhones(form) {
    var inputs = form.querySelectorAll('.mgf-tel-intl');
    if (!inputs.length) return true;
    var ok = true, first = null;
    Array.prototype.forEach.call(inputs, function (input) {
      var iti = input._mgfIti;
      if (!iti || input.disabled) return;
      if (!(input.value || '').trim()) return;
      var valid = true;
      try { valid = iti.isValidNumber(); } catch (e) { valid = true; } // sin utils → no bloquea
      if (valid === false) {
        ok = false;
        var wrap = input.closest('.mgf-field');
        if (wrap) {
          wrap.classList.add('mgf-field--error');
          var old = wrap.querySelector('.mgf-error'); if (old) old.remove();
          var p = document.createElement('p');
          p.className = 'mgf-error';
          p.setAttribute('role', 'alert');
          p.textContent = 'Introduce un número de teléfono válido.';
          wrap.appendChild(p);
        }
        input.setAttribute('aria-invalid', 'true');
        if (!first) first = input;
      }
    });
    if (first) first.focus();
    return ok;
  }

  // Valida los grupos de radios obligatorios (.mgf-choices con input required).
  // Ignora los campos ocultos por lógica condicional (.mgf-cond) y los inputs
  // deshabilitados. Marca inline y devuelve false si falta alguna selección.
  function validateChoiceGroups(form) {
    var groups = form.querySelectorAll('.mgf-field .mgf-choices');
    if (!groups.length) return true;
    var ok = true, first = null;
    Array.prototype.forEach.call(groups, function (group) {
      var radios = group.querySelectorAll('input[type="radio"][required]');
      if (!radios.length) return;
      var wrap = group.closest ? group.closest('.mgf-field') : null;
      if (!wrap || wrap.classList.contains('mgf-cond')) return;

      var enabled = false, checked = false;
      Array.prototype.forEach.call(radios, function (r) {
        if (r.disabled) return;
        enabled = true;
        if (r.checked) checked = true;
      });
      if (!enabled || checked) return;

      ok = false;
      wrap.classList.add('mgf-field--error');
      var old = wrap.querySelector('.mgf-error'); if (old) old.remove();
      var p = document.createElement('p');
      p.className = 'mgf-error';
      p.setAttribute('role', 'alert');
      p.textContent = 'Selecciona una opción para continuar.';
      wrap.appendChild(p);
      Array.prototype.forEach.call(radios, function (r) { r.setAttribute('aria-invalid', 'true'); });
      if (!first) first = wrap;
    });
    if (first && first.scrollIntoView) {
      try { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { first.scrollIntoView(); }
    }
    return ok;
  }

  // Antes de enviar, normaliza cada teléfono a formato internacional E.164 (+34…)
  // para que el CRM/notificaciones reciban un número limpio. Si utils no cargó,
  // reconstruye +<prefijo><nacional> con el país seleccionado.
  function normalizePhones(form) {
    var inputs = form.querySelectorAll('.mgf-tel-intl');
    Array.prototype.forEach.call(inputs, function (input) {
      var iti = input._mgfIti;
      if (!iti || input.disabled) return;
      var num = '';
      try { num = iti.getNumber() || ''; } catch (e) {}
      if (num && num.charAt(0) === '+') {
        input.value = num;
      } else if ((input.value || '').trim()) {
        var national = input.value.replace(/\D/g, '');
        var d = null;
        try { d = iti.getSelectedCountryData(); } catch (e) {}
        if (national) input.value = (d && d.dialCode ? '+' + d.dialCode : '') + national;
      }
    });
  }

  /**
   * Lógica condicional de campos: muestra/oculta campos en vivo según el valor
   * de otros (equivalente a la conditional logic de GF). Espeja mgf_eval_condition
   * del servidor. Los campos ocultos se deshabilitan para que no se envíen ni
   * disparen validación required.
   */
  function setupConditions(form) {
    var nodes    = form.querySelectorAll('.mgf-field[data-mgf-cond]');
    var optNodes = form.querySelectorAll('option[data-mgf-optcond]');
    if (!nodes.length && !optNodes.length) return;

    var specs = [];
    Array.prototype.forEach.call(nodes, function (el) {
      try {
        var d = JSON.parse(el.getAttribute('data-mgf-cond'));
        specs.push({ el: el, action: d.action || 'show', cond: d.cond });
      } catch (e) {}
    });

    // Opciones condicionales de un <select> (p.ej. "Les Franqueses" solo Peugeot):
    // mostramos/ocultamos la <option> sin duplicar el select (evita el bug de dos
    // selects con el mismo name que pisaba el valor → centro vacío en Walcu).
    var optSpecs = [];
    Array.prototype.forEach.call(optNodes, function (op) {
      try {
        var d = JSON.parse(op.getAttribute('data-mgf-optcond'));
        optSpecs.push({ op: op, sel: op.parentNode, action: d.action || 'show', cond: d.cond });
      } catch (e) {}
    });

    function getVal(name) {
      var els = form.querySelectorAll('[name="' + name + '"], [name="' + name + '[]"]');
      if (!els.length) return '';
      var first = els[0];
      if (first.type === 'checkbox' || first.type === 'radio') {
        var vals = [];
        Array.prototype.forEach.call(els, function (i) { if (i.checked) vals.push(i.value); });
        return vals.join(', ');
      }
      return first.value || '';
    }

    function matchRule(r) {
      // Case-insensitive como Gravity Forms (baja ambos a minúsculas): la regla
      // 'citro' casa con "Citroën", 'eugeo' con "Peugeot", etc.
      var v = String(getVal(r.field) || '').toLowerCase();
      var t = String(r.value != null ? r.value : '').toLowerCase();
      switch (r.op) {
        case 'is':           return v === t;
        case 'isnot':        return v !== t;
        case 'contains':     return t !== '' && v.indexOf(t) !== -1;
        case 'starts_with':  return t !== '' && v.indexOf(t) === 0;
        case 'ends_with':    return t !== '' && v.slice(-t.length) === t;
        case 'greater_than': return parseFloat(v) > parseFloat(t);
        case 'less_than':    return parseFloat(v) < parseFloat(t);
        default:             return true;
      }
    }

    function evalCond(cond) {
      if (!cond) return true;
      if (cond.rules && cond.rules.length) {
        var any = (cond.logic || 'all').toLowerCase() === 'any';
        for (var i = 0; i < cond.rules.length; i++) {
          var ok = matchRule(cond.rules[i]);
          if (any && ok) return true;
          if (!any && !ok) return false;
        }
        return !any;
      }
      if (cond.field) return matchRule(cond);
      return true;
    }

    function apply() {
      specs.forEach(function (s) {
        var match = evalCond(s.cond);
        var visible = s.action === 'hide' ? !match : match;
        // Alternamos la clase .mgf-cond (que es la que aplica display:none en CSS).
        // NO vale con style.display='' para mostrar: eso solo borra el inline y el
        // campo revierte a la regla .mgf-cond{display:none}, quedándose oculto.
        if (visible) s.el.classList.remove('mgf-cond');
        else s.el.classList.add('mgf-cond');
        var inputs = s.el.querySelectorAll('input, select, textarea');
        Array.prototype.forEach.call(inputs, function (i) { i.disabled = !visible; });
      });

      // Opciones condicionales: ocultar/mostrar la <option>. hidden+disabled = ni se
      // ve ni se puede seleccionar. Si la opción oculta estaba elegida, reseteamos el
      // select al placeholder para no enviar un valor no válido.
      optSpecs.forEach(function (s) {
        var match = evalCond(s.cond);
        var visible = s.action === 'hide' ? !match : match;
        s.op.hidden = !visible;
        s.op.disabled = !visible;
        if (!visible && s.sel && s.sel.value === s.op.value) s.sel.value = '';
      });
    }

    // Campos que disparan alguna condición (los referidos en las reglas).
    var triggers = {};
    specs.concat(optSpecs).forEach(function (s) {
      var c = s.cond;
      if (c && c.rules) c.rules.forEach(function (r) { if (r.field) triggers[r.field] = 1; });
      else if (c && c.field) triggers[c.field] = 1;
    });
    triggers = Object.keys(triggers);
    function snapshot() { return triggers.map(getVal).join(''); }
    var lastSnap = snapshot();

    function run() { apply(); lastSnap = snapshot(); }

    form.addEventListener('input', run);
    form.addEventListener('change', run);
    run(); // estado inicial

    // El tema rellena algunos campos (p.ej. el mensaje de la oferta en la ficha,
    // o al abrir el modal en un listado) por JS y SIN disparar 'input'/'change'.
    // Vigilamos los campos disparadores y reaplicamos si cambian sin evento.
    if (triggers.length) {
      setInterval(function () {
        var now = snapshot();
        if (now !== lastSnap) { lastSnap = now; apply(); }
      }, 500);
    }
  }

  /**
   * Inicializa flatpickr en los campos de fecha (.mgf-datepicker) con las reglas
   * de la definición: minDate/maxDate (calculadas en servidor) y días de la
   * semana deshabilitados. Locale español, formato d/m/Y.
   */
  function setupDatepickers(form) {
    var inputs = form.querySelectorAll('.mgf-datepicker');
    if (!inputs.length) return;

    function init() {
      if (typeof window.flatpickr === 'undefined') return false;
      Array.prototype.forEach.call(inputs, function (el) {
        if (el._mgfFp) return;
        var cfg = {};
        try { cfg = JSON.parse(el.getAttribute('data-mgf-date') || '{}'); } catch (e) {}
        var opts = {
          locale: 'es',
          dateFormat: 'd/m/Y',
          minDate: cfg.minDate || null,
          maxDate: cfg.maxDate || null,
          allowInput: false,
          // inline: el calendario se pinta SIEMPRE en el flujo (no popup absoluto),
          // así no se recorta dentro de un paso multipágina / contenedor con overflow.
          inline: !!cfg.inline
        };
        if (cfg.disableWeekdays && cfg.disableWeekdays.length) {
          opts.disable = [function (date) { return cfg.disableWeekdays.indexOf(date.getDay()) !== -1; }];
        }
        el._mgfFp = window.flatpickr(el, opts);
      });
      return true;
    }

    if (!init()) {
      var tries = 0;
      var t = setInterval(function () { if (init() || ++tries > 40) clearInterval(t); }, 200);
    }
  }

  /**
   * Selector de CITA (type=appointment): calendario (día) + slots (hora) en un
   * solo campo. El horario es por día de la semana y puede variar según otro
   * campo (p.ej. el centro: 'scheduleField'). Al elegir día se generan los slots
   * de ese día; al elegir slot se compone el valor "d/m/Y H:i" en el input hidden.
   * Espeja la lógica de servidor (MGF_Field::appointment_*).
   */
  function setupAppointments(form) {
    var widgets = form.querySelectorAll('.mgf-appointment');
    if (!widgets.length) return;

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function fmt(d) { return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear(); }
    function startOfToday() { var d = new Date(); d.setHours(0, 0, 0, 0); return d; }
    function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }

    // Genera los slots "HH:MM" de un día (0=dom..6=sáb) según los rangos del horario.
    function slotsFor(cfg, weekday) {
      var ranges = (cfg.schedule && cfg.schedule[weekday]) ? cfg.schedule[weekday] : [];
      var step = Math.max(5, parseInt(cfg.slotMinutes, 10) || 60);
      var out = [];
      for (var r = 0; r < ranges.length; r++) {
        var range = ranges[r];
        if (!range || range.length < 2) continue;
        var t = toMin(range[0]), e = toMin(range[1]);
        while (t < e && out.length < 200) { out.push(fromMin(t)); t += step; }
      }
      return out;
    }
    function toMin(hhmm) { var p = String(hhmm).split(':'); return (parseInt(p[0], 10) || 0) * 60 + (parseInt(p[1], 10) || 0); }
    function fromMin(m) { return pad(Math.floor(m / 60)) + ':' + pad(m % 60); }

    Array.prototype.forEach.call(widgets, function (el) {
      if (el._mgfApp) return;
      el._mgfApp = true;

      var conf = {};
      try { conf = JSON.parse(el.getAttribute('data-mgf-appointment') || '{}'); } catch (e) {}
      var wrap    = el.closest('.mgf-field') || el.parentNode;
      var input   = wrap.querySelector('.mgf-appointment-value');
      var calEl   = el.querySelector('.mgf-appointment-cal');
      var slotsEl = el.querySelector('.mgf-appointment-slots');
      var required = el.getAttribute('data-required') === '1';
      var fp = null, activeCfg = null, chosenDate = null;

      // Resuelve el horario efectivo: default + override por 'scheduleField' (centro).
      function resolveCfg() {
        var base = conf.default || {};
        var merged = {
          slotMinutes: base.slotMinutes || 60,
          minLeadDays: base.minLeadDays || 0,
          maxDays: base.maxDays || 45,
          schedule: base.schedule || {},
          disabledDates: base.disabledDates || []
        };
        var sf = conf.scheduleField;
        if (sf && conf.schedules) {
          var el2 = form.querySelector('[name="' + sf + '"]');
          var v = el2 ? (el2.value || '') : '';
          if (v && conf.schedules[v]) {
            var o = conf.schedules[v];
            if (o.slotMinutes != null) merged.slotMinutes = o.slotMinutes;
            if (o.minLeadDays != null) merged.minLeadDays = o.minLeadDays;
            if (o.maxDays != null) merged.maxDays = o.maxDays;
            if (o.schedule) merged.schedule = o.schedule;
            if (o.disabledDates) merged.disabledDates = o.disabledDates;
          }
        }
        return merged;
      }

      function openWeekdays(cfg) {
        var days = {};
        for (var k in cfg.schedule) { if (cfg.schedule.hasOwnProperty(k) && cfg.schedule[k] && cfg.schedule[k].length) days[parseInt(k, 10)] = 1; }
        return days;
      }

      function renderSlots(date) {
        slotsEl.innerHTML = '';
        chosenDate = date;
        var list = date ? slotsFor(activeCfg, date.getDay()) : [];
        if (!date) {
          slotsEl.innerHTML = '<p class="mgf-appointment-hint">Elige primero un día en el calendario.</p>';
          return;
        }
        if (!list.length) {
          slotsEl.innerHTML = '<p class="mgf-appointment-hint">No hay horas disponibles ese día. Elige otro.</p>';
          return;
        }
        var current = input.value ? input.value.split(/\s+/)[1] : '';
        var sameDay = input.value && input.value.split(/\s+/)[0] === fmt(date);
        list.forEach(function (slot) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'mgf-appointment-slot';
          b.textContent = slot;
          if (sameDay && slot === current) b.classList.add('is-selected');
          b.addEventListener('click', function () {
            Array.prototype.forEach.call(slotsEl.querySelectorAll('.mgf-appointment-slot'), function (x) { x.classList.remove('is-selected'); });
            b.classList.add('is-selected');
            input.value = fmt(date) + ' ' + slot;
            input.dispatchEvent(new Event('input', { bubbles: true })); // avisa a otros módulos (p.ej. cita previa)
            clearFieldError(wrap);
          });
          slotsEl.appendChild(b);
        });
      }

      function build() {
        activeCfg = resolveCfg();
        var today = startOfToday();
        var min = addDays(today, activeCfg.minLeadDays);
        var max = addDays(today, activeCfg.maxDays);
        var open = openWeekdays(activeCfg);
        var disabled = (activeCfg.disabledDates || []).slice();

        if (fp) { try { fp.destroy(); } catch (e) {} fp = null; }
        calEl.innerHTML = '';

        // Preselección (repoblado): si el input ya trae "d/m/Y H:i".
        var preDate = null;
        if (input.value) {
          var parts = input.value.split(/\s+/);
          var dmy = (parts[0] || '').split('/');
          if (dmy.length === 3) preDate = new Date(parseInt(dmy[2], 10), parseInt(dmy[1], 10) - 1, parseInt(dmy[0], 10));
        }

        var opts = {
          locale: 'es',
          inline: true,
          dateFormat: 'd/m/Y',
          minDate: min,
          maxDate: max,
          defaultDate: preDate || null,
          disable: [function (d) {
            if (!open[d.getDay()]) return true;
            var iso = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
            return disabled.indexOf(iso) !== -1;
          }],
          onChange: function (sel) { renderSlots(sel && sel[0] ? sel[0] : null); }
        };
        fp = window.flatpickr(calEl, opts);
        renderSlots(preDate);
      }

      function init() {
        if (typeof window.flatpickr === 'undefined') return false;
        build();
        // Si el horario depende del centro, reconstruir cuando cambie ese campo.
        if (conf.scheduleField) {
          var last = '';
          var watch = function () {
            var f = form.querySelector('[name="' + conf.scheduleField + '"]');
            var v = f ? (f.value || '') : '';
            if (v !== last) { last = v; input.value = ''; build(); }
          };
          form.addEventListener('change', watch);
          form.addEventListener('input', watch);
          setInterval(watch, 500); // el tema rellena el centro por JS sin disparar eventos
        }
        return true;
      }

      if (!init()) {
        var tries = 0;
        var t = setInterval(function () { if (init() || ++tries > 40) clearInterval(t); }, 200);
      }

      // Validación cliente: bloquea el envío si es obligatorio y no hay cita.
      el._mgfValidate = function () {
        if (required && !input.value) {
          markFieldError(wrap, 'Elige día y hora para tu cita.');
          return false;
        }
        return true;
      };
    });

    // Se registra ANTES del listener de envío principal (initForm), así que su
    // stopImmediatePropagation impide el fetch si la cita obligatoria falta.
    form.addEventListener('submit', function (e) {
      var ok = true, first = null;
      Array.prototype.forEach.call(form.querySelectorAll('.mgf-appointment'), function (el) {
        if (el.offsetParent === null) return; // oculto (otro paso / condición): no valida
        if (el._mgfValidate && !el._mgfValidate()) { ok = false; if (!first) first = el; }
      });
      if (!ok) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (first) { try { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (er) {} }
      }
    });
  }

  function markFieldError(wrap, msg) {
    if (!wrap) return;
    wrap.classList.add('mgf-field--error');
    var old = wrap.querySelector('.mgf-error'); if (old) old.remove();
    var p = document.createElement('p');
    p.className = 'mgf-error';
    p.setAttribute('role', 'alert');
    p.textContent = msg;
    wrap.appendChild(p);
  }
  function clearFieldError(wrap) {
    if (!wrap) return;
    wrap.classList.remove('mgf-field--error');
    var old = wrap.querySelector('.mgf-error'); if (old) old.remove();
  }

  /**
   * Navegación multipágina (pasos). Muestra un .mgf-step a la vez; "Siguiente"
   * valida los campos del paso actual (native validity, respetando novalidate)
   * antes de avanzar. Sin JS se ven todos los pasos (fallback de una página).
   */
  function setupSteps(form) {
    var container = form.querySelector('.mgf-steps');
    if (!container) return;
    var steps = container.querySelectorAll('.mgf-step');
    var dots  = container.querySelectorAll('.mgf-progress-dot');
    if (steps.length < 2) return;
    var current = 0;
    container.classList.add('mgf-steps--js'); // activa el ocultado por CSS (sin JS se ven todos)

    function show(idx) {
      Array.prototype.forEach.call(steps, function (s, i) { s.classList.toggle('is-active', i === idx); });
      Array.prototype.forEach.call(dots, function (d, i) { d.classList.toggle('is-active', i <= idx); });
      current = idx;
      var f = steps[idx].querySelector('input:not([type=hidden]), select, textarea');
      if (f) { try { f.focus(); } catch (e) {} }
      try { form.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }

    function validateStep(idx) {
      var els = steps[idx].querySelectorAll('input, select, textarea');
      for (var i = 0; i < els.length; i++) {
        if (els[i].disabled) continue;
        if (typeof els[i].checkValidity === 'function' && !els[i].checkValidity()) {
          if (els[i].reportValidity) els[i].reportValidity();
          return false;
        }
      }
      // Citas (appointment) del paso: no son campos nativos, validan aparte.
      var apps = steps[idx].querySelectorAll('.mgf-appointment');
      for (var j = 0; j < apps.length; j++) {
        if (apps[j]._mgfValidate && !apps[j]._mgfValidate()) return false;
      }
      return true;
    }

    container.addEventListener('click', function (e) {
      if (e.target.classList.contains('mgf-next')) {
        e.preventDefault();
        if (validateStep(current)) show(Math.min(current + 1, steps.length - 1));
      } else if (e.target.classList.contains('mgf-prev')) {
        e.preventDefault();
        show(Math.max(current - 1, 0));
      }
    });
  }

  /**
   * UX del formulario de CITA PREVIA (form-83). Réplica del comportamiento por
   * tarjetas del Gravity Form original (main.js del tema): coche/moto → marca
   * (filtrada por vehículo) → particular/empresa → centro (filtrado por marca +
   * tipo cliente) → tipo de revisión, con revelado progresivo de secciones. El
   * calendario gAppointments se sustituye por el campo `appointment` (que se
   * reconfigura solo según el centro elegido, vía schedule_field=selectorcentro).
   * Solo actúa sobre formularios con clase .mgf-cita-previa.
   */
  function setupCitaPrevia(form) {
    if (!form.classList.contains('mgf-cita-previa')) return;
    if (form._mgfCita) return;
    form._mgfCita = true;

    // Los carriers tienen name = data-input (tipovehiculo, selectorcentro, …); el
    // hidden webview también se localiza por name. Fallback a la clase del wrapper.
    function carrier(name) {
      return form.querySelector('[name="' + name + '"]') || form.querySelector('.' + name + ' input, .' + name + ' textarea');
    }
    function setCarrier(name, val) {
      var el = carrier(name);
      if (!el) return;
      el.value = val;
      el.dispatchEvent(new Event('input', { bubbles: true }));
    }
    function getCarrier(name) { var el = carrier(name); return el ? el.value : ''; }
    function reveal(n) {
      Array.prototype.forEach.call(form.querySelectorAll('.section' + n), function (el) { el.classList.add('is-revealed'); });
    }
    function scrollToSel(sel) {
      var el = form.querySelector(sel);
      if (el) { try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
    }
    function actives(sel) { return form.querySelectorAll(sel + '.active'); }

    // Filtra los centros marcando .unselectable los que no aplican a la marca.
    function exceptionDrivimCP(li) {
      if (!li.classList.contains('active')) return;
      Array.prototype.forEach.call(form.querySelectorAll('.selectorcentro li.unselectable'), function (c) { c.classList.remove('unselectable'); });
      var brand = li.getAttribute('data-tipo');
      var keep = {
        'Subaru': 'centroSubaru', 'Opel': 'centroOpel', 'DS': 'centroDS', 'Citroën': 'centroCitroen',
        'Piaggio': 'centroPiaggio', 'Vespa': 'centroVespa', 'Aprilia': 'centroAprilia', 'Guzzi': 'centroGuzzi',
        'Peugeot': 'centroPeugeot', 'Fiat': 'centroFiat', 'Abarth': 'centroAbarth', 'Jeep': 'centroJeep',
        'LeapMotor': 'centroLeapMotor', 'OtherCar': 'centroAllCar', 'OtherMoto': 'centroAllMoto'
      }[brand];
      if (keep) {
        Array.prototype.forEach.call(form.querySelectorAll('.selectorcentro li'), function (c) {
          if (!c.classList.contains(keep)) c.classList.add('unselectable');
        });
      }
      // El taller de empresas siempre queda disponible.
      Array.prototype.forEach.call(form.querySelectorAll('.selectorcentro .centroEmpresa.unselectable'), function (c) { c.classList.remove('unselectable'); });
    }

    // Delegación de clicks en las tarjetas.
    form.addEventListener('click', function (e) {
      var li = e.target.closest ? e.target.closest('li') : null;
      if (!li) return;
      var ul = li.parentNode;

      // --- Tipo de vehículo (coche/moto) ---
      if (ul.classList.contains('selectVehicleType')) {
        // Reset centros al cambiar de vehículo.
        Array.prototype.forEach.call(form.querySelectorAll('.selectorcentro li.active'), function (c) { c.classList.remove('active'); });
        setCarrier('selectorcentro', '');
        Array.prototype.forEach.call(ul.querySelectorAll('.active'), function (a) { a.classList.remove('active'); });
        li.classList.add('active');
        var vt = li.getAttribute('data-vehicle');
        setCarrier('tipovehiculo', vt);
        // Mostrar solo las marcas de ese tipo de vehículo.
        Array.prototype.forEach.call(form.querySelectorAll('.selectMarca li'), function (m) {
          m.style.display = (m.getAttribute('data-vehicle') === vt) ? 'inline-block' : 'none';
          m.classList.remove('active');
        });
        setCarrier('tipomarca', '');
        // Empresa/autónomo solo para coches.
        Array.prototype.forEach.call(form.querySelectorAll('.selectorempresa li[data-vehicle="empresa"]'), function (em) {
          if (vt === 'car') em.classList.remove('unselectable'); else em.classList.add('unselectable');
        });
        reveal(1);
        scrollToSel('.htmlSelectorMarca');
        return;
      }

      // --- Marca ---
      if (ul.classList.contains('selectMarca')) {
        Array.prototype.forEach.call(form.querySelectorAll('.selectorcentro li.active'), function (c) { c.classList.remove('active'); });
        setCarrier('selectorcentro', '');
        Array.prototype.forEach.call(ul.querySelectorAll('.active'), function (a) { a.classList.remove('active'); });
        li.classList.add('active');
        setCarrier('tipomarca', li.getAttribute('data-tipo'));
        exceptionDrivimCP(li);
        reveal(2);
        scrollToSel('.htmlSelectorEmpresa');
        return;
      }

      // --- Particular / Empresa ---
      if (ul.classList.contains('selectorempresa')) {
        if (li.classList.contains('unselectable')) return;
        Array.prototype.forEach.call(ul.querySelectorAll('.active'), function (a) { a.classList.remove('active'); });
        li.classList.add('active');
        var client = li.getAttribute('data-vehicle');
        setCarrier('selectorempresa', client);
        Array.prototype.forEach.call(form.querySelectorAll('.selectorcentro li.centroParticular'), function (c) { c.classList.toggle('hidden', client !== 'particular'); });
        Array.prototype.forEach.call(form.querySelectorAll('.selectorcentro li.centroEmpresa'), function (c) { c.classList.toggle('hidden', client !== 'empresa'); });
        // Centros de empresa restringidos por marca (data-brand): solo visibles si la
        // marca coincide. data-brand admite una LISTA separada por comas (p.ej.
        // "Peugeot,Fiat,Abarth,Jeep") → visible si la marca actual está en la lista.
        if (client === 'empresa') {
          var currentBrand = getCarrier('tipomarca') || '';
          Array.prototype.forEach.call(form.querySelectorAll('.selectorcentro li.centroEmpresa[data-brand]'), function (c) {
            var brands = (c.getAttribute('data-brand') || '').split(',').map(function (s) { return s.trim(); });
            if (brands.indexOf(currentBrand) === -1) c.classList.add('hidden');
          });
        }
        reveal(3);
        scrollToSel('.htmlSelectorCentro');
        return;
      }

      // --- Centro ---
      if (ul.classList.contains('selectorcentro')) {
        if (li.classList.contains('unselectable')) return;
        Array.prototype.forEach.call(ul.querySelectorAll('.active'), function (a) { a.classList.remove('active'); });
        li.classList.add('active');
        setCarrier('selectorcentro', li.getAttribute('data-tipo')); // reconfigura el calendario (schedule_field)
        reveal(4);
        scrollToSel('.htmlSelectorRevision');
        return;
      }

      // --- Tipo de revisión (multi) ---
      if (ul.classList.contains('selectRevision')) {
        if (li.classList.contains('unselectable')) return;
        li.classList.toggle('active');
        var vals = [];
        Array.prototype.forEach.call(actives('.selectRevision li'), function (a) { vals.push(a.getAttribute('data-tipo')); });
        setCarrier('tiporevision', vals.join(','));
        // Aviso Carrocería + Badalona.
        var centro = getCarrier('selectorcentro') || '';
        var rev = getCarrier('tiporevision') || '';
        var aviso = form.querySelector('.avisoBDNCarroceria');
        if (aviso) aviso.style.display = (centro.indexOf('Badalona') >= 0 && rev.indexOf('Carrocer') >= 0) ? 'block' : 'none';
        return;
      }
    });

    // Al elegir fecha+hora en el calendario, revelar la sección de datos y el botón.
    form.addEventListener('input', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('mgf-appointment-value') && e.target.value) {
        reveal(5);
        form.classList.add('cita-ready'); // el CSS muestra el botón de envío
      }
    });

    // Pre-población por URL: ?type=car|moto (auto-selecciona el vehículo).
    try {
      var params = new URLSearchParams(window.location.search);
      var type = params.get('type');
      if (type) {
        var btn = form.querySelector('.selectVehicleType li[data-vehicle="' + type + '"]');
        if (btn) btn.click();
      }
      var wv = params.get('webview');
      if (wv) setCarrier('webview', wv);
    } catch (e) {}
  }

  function resetTurnstile(form) {
    if (typeof window.turnstile === 'undefined') return;
    var state = form._mgfTs;
    try {
      if (state && state.id !== null) window.turnstile.reset(state.id);
      else {
        var w = form.querySelector('.cf-turnstile');
        if (w) window.turnstile.reset(w);
      }
    } catch (e) {}
  }
})();
